module.exports = __webpack_public_path__ + "static/media/trophy-line-1.a23c27d9.svg";